import { WebPage } from "~/components/layout/WebPage";
import { QENDO_LINKS } from "~/constants/environment";

export default function CarerSupport() {
    return <WebPage title="Carer Support" uri={QENDO_LINKS.carer_support} />;
}
